import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateUserSaga } from "src/store/users/saga";
import { UserDetailDto } from "src/store/users/type";
import * as Yup from "yup";

const UserEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: UserDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Users.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Surname: data.Surname,
          Email: data.Email,
          PhoneNumber: data.PhoneNumber,
        }}
        onSubmit={(values) => {
          dispatch(
            updateUserSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(t(message), {
                    theme: "colored",
                  });
                },
              },
              body: values,
              id: data.Id,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Surname: Yup.string().required(t("Validation.Required").toString()),
          Email: Yup.string()
            .required(t("Validation.Required").toString())
            .email(t("Validation.Email").toString()),
        })}
        inputs={[
          {
            field: "Name",
            label: t("Users.Name").toString(),
          },
          {
            field: "Surname",
            label: t("Users.Surname").toString(),
          },
          {
            field: "Email",
            label: t("Users.Email").toString(),
          },
          {
            field: "PhoneNumber",
            label: t("Users.PhoneNumber").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default UserEditForm;
